import { render } from "./HomeNews.vue?vue&type=template&id=15ce868e&scoped=true"
import script from "./HomeNews.vue?vue&type=script&lang=js"
export * from "./HomeNews.vue?vue&type=script&lang=js"

import "./HomeNews.vue?vue&type=style&index=0&id=15ce868e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-15ce868e"

export default script